import { useCallback, useMemo } from 'react'
import { ListChecks, Trash2 } from 'lucide-react'
import { PageHeader } from '@/shell/AppShell'
import { DataTable } from '@/components/DataTable'
import type { AdminColumn, RowAction } from '@/components/DataTable/types'
import { PERMISSIONS } from '@/lib/permissions'
import { useToast } from '@/providers/UiProviders'
import { fetchBlacklist, removeBlacklist, FRAUD_STR as S, type BlacklistRow } from './fraudApi'

/**
 * A25.15 — Чёрные списки (ip/device/phone/email/card). Remove an entry. Dormant
 * until `/admin/antifraud/blacklist` ships. Placeholder permission USERS_VIEW.
 */
export function BlacklistsScreen() {
  const { toast } = useToast()

  const columns = useMemo<AdminColumn<BlacklistRow>[]>(
    () => [
      { key: 'kind', header: S.kind, type: 'text' },
      { key: 'value', header: S.value, type: 'text' },
      { key: 'reason', header: S.reason, type: 'text' },
      { key: 'added_at', header: S.added, type: 'text' },
    ],
    [],
  )

  const rowActions = useMemo<RowAction<BlacklistRow>[]>(
    () => [
      {
        id: 'remove',
        label: S.remove,
        icon: <Trash2 size={14} />,
        danger: true,
        onSelect: async (r) => {
          try {
            await removeBlacklist(r.id)
            toast(S.removed, { tone: 'success' })
          } catch {
            toast(S.failed, { tone: 'error' })
          }
        },
      },
    ],
    [toast],
  )

  const fetcher = useCallback(fetchBlacklist, [])
  return (
    <>
      <PageHeader title={S.blacklist} screenId="A25.15" />
      <DataTable<BlacklistRow>
        screenId="A25.15"
        permission={PERMISSIONS.USERS_VIEW}
        columns={columns}
        fetcher={fetcher}
        rowId={(r) => String(r.id)}
        rowActions={rowActions}
        exportable
        emptyState={{ icon: <ListChecks size={28} strokeWidth={1.5} /> }}
      />
    </>
  )
}
